import SpriteSymbol from "../../../../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "share",
  "use": "share-usage",
  "viewBox": "0 0 28 30",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 30\" id=\"share\"><path fill=\"var(--bolt-theme-icon, currentColor)\" d=\"M22 18a6 6 0 00-4.8 2.4L12 17.3A6.2 6.2 0 0012 16a6 6 0 00-.3-1.8l6.4-3.7A6 6 0 0022 12a6 6 0 10-6-6 6.4 6.4 0 00.1 1l-6.8 4A6 6 0 106 22a6 6 0 003.7-1.3l6.3 3.6a6 6 0 106-6.3zm0-14a2 2 0 11-2 2 2 2 0 012-2zM6 18a2 2 0 112-2 2 2 0 01-2 2zm16 8a2 2 0 112-2 2 2 0 01-2 2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol